import * as RxOp from "rxjs/operators";
import * as Rx from "rxjs";
import { get, compose, prop } from "partial.lenses";
import { push } from "connected-react-router";
import { addAlert, clearAlerts } from "/components/alert-bar/AlertBar.state";
import {
  editCreditCardAlertBarAction,
  profileWalletSettingsAlertBarAction,
  upsertCreditCard,
  CREDIT_CARD_RESOURCE,
  SUBMIT_OPERATIONS,
  SUBMIT_CHANGE,
  requestFailure,
  requestSuccess,
  handlePaymentExpiration
} from "../../Profile.state";
import {
  getEditCreditCardForm,
  getCustomerManagement,
  getCaptchaForm
} from "../../Profile.selectors";
import { updateTokenizedCreditCard } from "../../graphql/Queries";
import { isInCustomerManagement, configureEndpoint } from "/util/router-utils";

const _formFieldRaw = fieldName =>
  compose(getEditCreditCardForm, prop(fieldName), prop("rawValue"));

const _formFieldRawCaptcha = fieldName =>
  compose(getCaptchaForm, prop(fieldName), prop("rawValue"));

const getEditCreditCardArgs = (key, selectors, state, id) => ({
  endpoint: selectors.getGraphqlServiceEndpoint(state),
  clientSlug: selectors.getClientSlug(state),
  authJwt: isInCustomerManagement
    ? selectors.getAdminAccessToken(state)
    : selectors.getAccessToken(state),
  id,
  userID: isInCustomerManagement
    ? state.profile.customerManagement.profileId
    : selectors.getUserID(state),
  expiryMonth: get(_formFieldRaw("expirationDate"), state[key]).slice(0, 2),
  expiryYear: get(_formFieldRaw("expirationDate"), state[key]).slice(2),
  zipCode: get(_formFieldRaw("zipCode"), state[key]),
  country: get(_formFieldRaw("country"), state[key]),
  captchaToken: get(_formFieldRawCaptcha("captchaToken"), state[key]),
  captchaProvider: get(_formFieldRawCaptcha("captchaProvider"), state[key])
});

export const editCreditCardEpic = (profileKey, selectors) => (
  action$,
  state$
) =>
  action$.ofType(SUBMIT_CHANGE).pipe(
    RxOp.filter(
      ({ payload: { settingName, operation } }) =>
        settingName === CREDIT_CARD_RESOURCE &&
        operation === SUBMIT_OPERATIONS.EDIT
    ),
    RxOp.flatMap(action =>
      Rx.from(
        updateTokenizedCreditCard(
          getEditCreditCardArgs(
            profileKey,
            selectors,
            state$.value,
            action.payload.id
          )
        )
      ).pipe(
        RxOp.flatMap(response =>
          Rx.of(
            editCreditCardAlertBarAction(clearAlerts()),
            requestSuccess(CREDIT_CARD_RESOURCE, SUBMIT_OPERATIONS.EDIT),
            upsertCreditCard(response.updateCreditCard),
            handlePaymentExpiration(),
            profileWalletSettingsAlertBarAction(clearAlerts()),
            profileWalletSettingsAlertBarAction(
              addAlert({
                heading: "Credit Card Updated",
                text: "Your credit card has been successfully updated.",
                variant: "success"
              })
            ),
            push(
              configureEndpoint(
                getCustomerManagement(state$.value[profileKey]),
                "/profile/wallet"
              )
            )
          )
        ),
        RxOp.catchError(err =>
          Rx.of(
            editCreditCardAlertBarAction(clearAlerts()),
            editCreditCardAlertBarAction(
              addAlert({
                heading: "Unable to Update Credit Card",
                text:
                  "Unable to process credit card update. Please check your information and try again.",
                variant: "error"
              })
            ),
            requestFailure(CREDIT_CARD_RESOURCE, err)
          )
        )
      )
    )
  );

export default editCreditCardEpic;
